import store from "../../../../../store";
import { DomainRegistry } from "../../../../../domain";
import { Directory } from "../../../../../domain/drawing";
import { FormatReference } from "../../../../../domain/format";
import { ITreeSource, IEditTreeSource } from ".";
import { IConfiguration } from "../../../../../domain/configuration";

export class UserFavoriteFormatTreeSource implements ITreeSource<FormatReference>, IEditTreeSource<FormatReference> {
  constructor(private _userId: string, private _shouldIgnoreChained: boolean, private _shouldIncludeReferenceableGroupFormats: boolean) {
  }

  private readonly config = store.getters.configuration as IConfiguration;
  entityName: string = "個人頻用" + this.config.wording.format.name + "情報";

  getTree(): Promise<Directory<string, FormatReference>[]> {
    const repository = DomainRegistry.format.getFormatRepository();
    return repository.getUserFavoriteFormats(this._userId, this._shouldIgnoreChained, this._shouldIncludeReferenceableGroupFormats);
  }

  saveEditTree(treeSource: Directory<string, FormatReference>[]): Promise<void> {
    const repository = DomainRegistry.format.getFormatRepository();
    return repository.setUserFavoriteFormats(this._userId, treeSource);
  }

  get managementKey(): string {
    return null;
  }
}
